const _events = new Map();

/**
 * Checks the event name structure
 * @param {any} eventName - Custom event name to be added
 */
const _checkEventNameValidity = (eventName: string): boolean => {
    const isValid = /[a-z]+(?::[a-z]){1,2}/.test(eventName)

    if (isValid == false) console.error(`${eventName} does not follow the required signature: 'modulename:eventname[:optionalsubeventname]'`)
    return isValid
}

/**
 * Adds custom event to events bus
 * @param {any} eventName - Custom event name to be added
 */
const _createEvent = (eventName: string) => {
    _checkEventNameValidity(eventName)
    _events.set(eventName, new Set())
}

/**
 * Adds a function to a given event array
 * @param {String} eventName - The custom event name to subscribe to
 * @param {Function} fn - function to be called when subscribed event is published
 */
const subscribe = (eventName: string, fn: () => {}) => {

    if (_events.has(eventName) == false) _createEvent(eventName)

    _events.get(eventName).add(fn)
}

/**
 * Removes a function from a given event array
 * @param {any} eventName - The custom event to unsubscribe from
 * @param {any} fn - The function to be removed from the call stack when the given event is published
 */
const unsubscribe = (eventName: string, fn: () => {}) =>
    _events.has(eventName)
        ? _events.get(eventName).delete(fn)
        : console.error(`${eventName} does not exist`)

/**
 * Calls all functions stored in the given event name array
 * @param {String} eventName - Custom event name to be subscribed to
 * @param {Object} data - Data to be consumed by subscriber functions
 */
const publish = (eventName: string, data?: {} = {}) => {
    if (_events.has(eventName)) _events.get(eventName).forEach(fn => fn(data))
}

const PubSub = { publish, subscribe, unsubscribe }
export default PubSub



// WEBPACK FOOTER //
// ./js/utils/PubSub.js